import React from "react";
import { Grid, InputAdornment, TextField } from "@mui/material";
import { Field } from "formik";
import { showAllinpayDynamicField } from "../../../utils/terminal_dynamic_util";

const AllinpayFields = ({ index, values, handleChange, touched, errors, selectedPaymentHost, section = "all" }) => {
  if (!showAllinpayDynamicField(selectedPaymentHost)) return null;

  const renderTextField = (name, label, required = true) => (
    <Grid item xs={2} key={name}>
      <Field
        name={`payment.${index}.${name}`}
        validate={(value) => required && !String(value ?? "").trim() ? "This field is required" : undefined}
      >
        {() => (
          <TextField
            required={required}
            sx={{ m: 1 }}
            InputLabelProps={{ shrink: true }}
            id={`payment.${index}.${name}`}
            name={`payment.${index}.${name}`}
            label={label}
            value={values.payment[index][name] ?? ""}
            onChange={handleChange}
            error={Boolean(touched.payment?.[index]?.[name] && errors.payment?.[index]?.[name])}
            helperText={touched.payment?.[index]?.[name] && errors.payment?.[index]?.[name]}
            variant="standard"
          />
        )}
      </Field>
    </Grid>
  );

  const renderRateField = (name, label) => (
    <Grid item xs={2} key={name}>
      <Field
        name={`payment.${index}.${name}`}
        validate={(value) => {
          if (value === "" || value === null || value === undefined) return "This field is required";
        }}
      >
        {() => (
          <TextField
            required
            sx={{ m: 1 }}
            InputLabelProps={{ shrink: true }}
            InputProps={{
              startAdornment: <InputAdornment position="start">%</InputAdornment>,
            }}
            type="number"
            id={`payment.${index}.${name}`}
            name={`payment.${index}.${name}`}
            label={label}
            value={values.payment[index][name] ?? ""}
            onChange={handleChange}
            error={Boolean(touched.payment?.[index]?.[name] && errors.payment?.[index]?.[name])}
            helperText={touched.payment?.[index]?.[name] && errors.payment?.[index]?.[name]}
            variant="standard"
          />
        )}
      </Field>
    </Grid>
  );

  return (
    <Grid container column={8} alignItems="center">
      {section !== "rates" && renderTextField("merchant_id", "Merchant ID")}
      {section !== "rates" && renderTextField("terminal_id", "Terminal ID")}
      {section !== "rates" && renderTextField("allinpay_partner_id", "Partner ID", false)}
      {section !== "identifiers" && renderRateField("allinpay_base_rate_local", "Base Rate (Local)")}
      {section !== "identifiers" && renderRateField("allinpay_markup_rate_local", "Markup Rate (Local)")}
      {section !== "identifiers" && renderRateField("allinpay_base_rate_foreign", "Base Rate (Foreign)")}
      {section !== "identifiers" && renderRateField("allinpay_markup_rate_foreign", "Markup Rate (Foreign)")}
    </Grid>
  );
};

export default AllinpayFields;
